module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"default_header":"Default Header in Component","toggle_accordian_section":"Toggle accordian section"},"fr":{"default_header":"En-tête par défaut dans le composant","toggle_accordian_section":"Basculer la section accordian"}}')
  delete Component.options._Ctor
}
